const MessageStatusObjectPriority = {
  enqueued: 1,
  sent: 2,
  delivered: 3,
  read: 4,
  failed: 0
};

const getStatusMessagePriority = (status, statusGupshup) => {
  if (!statusGupshup) {
    return status;
  }
  if (
    MessageStatusObjectPriority[status] >
    MessageStatusObjectPriority[statusGupshup]
  ) {
    return status;
  }
  return statusGupshup;
};

export default getStatusMessagePriority;
